<div [class.loader-hidden]="!show">
    <div class="loader-overlay" *ngIf="show">
        <i id="loader" class="fa fa-spinner fa-pulse fa-5x fa-fw"></i>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/templates/template1/views/app-loader.component.html